import { Box, styled } from '@mui/material';
import { SearchTable } from '@/components/Search/SearchTable';
import { useFetchAssetsWithoutMetadata } from '@/hooks/api/assets/useFetchAssetsWithoutMetadata';

const ViewRoot = styled(Box)({
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
});

export const AssetsWithoutMetadataView = () => {
  const { fetchData, error } = useFetchAssetsWithoutMetadata();

  return (
    <ViewRoot>
      <SearchTable fetchMatches={fetchData} isLoading={false} error={error} shouldShowSearchTabs={false} />
    </ViewRoot>
  );
};
